/**
 * HTML escaping for the map's STRING-BUILT popups.
 *
 * Shared, and by the same test everything else here is judged by: this states a
 * fact about HTML, not a decision about a product surface. `<` has to become
 * `&lt;` for Voyage Radar, for AISstream, and for any provider added after
 * them — there is no version of this a second implementer would be entitled to
 * answer differently. Compare `vessel-popup.ts`, which decides which paid
 * buttons a card carries and is therefore Voyage Radar's.
 *
 * WHY IT IS ITS OWN FILE. It lived inside `vessel-popup.ts`, which was fine
 * while that file was the only string builder on the map. It is not any more:
 * `poi-nearby-popup.ts` imported it, and when AISstream's cluster list needed
 * it (D10) the escaper was COPIED rather than shared — beside a comment saying
 * two copies is how one of them ends up not escaping. Both copies were correct
 * on the day. The hazard is the next fix, which lands in one of them.
 *
 * Pure: no `@angular/*`, no `leaflet`, no `this` (rule R1).
 */

const ESCAPES: { [char: string]: string } = {
  '<': '&lt;',
  '>': '&gt;',
  '&': '&amp;',
  '"': '&quot;',
};

/**
 * Everything interpolated into a popup goes through this — the properties come
 * from an upstream feed, so treat them as untrusted.
 *
 * For STRING BUILDERS only. An Angular template escapes its own interpolations,
 * so a component that renders these fields through a binding must not call this
 * first — that prints `&amp;` at the user.
 */
export function esc(value: any): string {
  return String(value ?? '').replace(/[<>&"]/g, (c) => ESCAPES[c]);
}
